/**
 * @file
 * A JavaScript file for Anchor Platform client / customer / company methods.
 *
 */

"use strict";

var company_tid;

(function($, Drupal) {

	$(document).ready(function() {
		modalOpenUser();
		customerSaveAndSend();
		orderArchivedRates();
		editDocs();
		viewLogs();
		disableCheckedByAnchor();
	});

	var modalOpenUser = function() {

		// Triggers company
		$(".js--add-company").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, company.addCompanyHTML($(this).data()), company.add, {
					action: $(this).data('action'),
				});
				$("body").addClass("modal-open");
			} else {
				$("body").removeClass("modal-open");
			}
		});


		$(".js--edit-company").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, company.editCompanyHTML($(this).data()), company.edit, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					autofire : true,
				});
				$("body").addClass("modal-open");
			} else {
				$("body").removeClass("modal-open");
			}
		});


		$(".js--delete-company").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, company.deleteCompanyHTML($(this).data()), company.delete, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
				});
				$("body").addClass("modal-open");
			} else {
				$("body").removeClass("modal-open");
			}
		});

		// Triggers contacts
		$(".js--add-contact").unbind('click').bind('click', function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, contact.addContactHTML($(this).data()), contact.addContact, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					name: $(this).data('name')
				});
				$('a.clear-access').unbind('click').bind('click', function(e) {
					e.preventDefault();
					$('#anchorModal .input-wrapper input[type="radio"]').attr('checked', false);
				});
				$("body").addClass("modal-open");
			} else {
				$("body").removeClass("modal-open");
			}
		});

		$(".js--edit-contact").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, contact.editContactHTML($(this).data()), contact.edit, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					uid: $(this).data('uid'),
					fullname: $(this).data('fullname'),
					autofire : true,
				});
				$("body").addClass("modal-open");
			} else {
				$("body").removeClass("modal-open");
			}
		});

		$(".js--delete-contact").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, contact.deleteContactHTML($(this).data()), contact.delete, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					uid: $(this).data('uid'),
					fullname: $(this).data('fullname'),
				});
				$("body").addClass("modal-open");
			} else {
				$("body").removeClass("modal-open");
			}
		});
	}

	var company = {
		addCompanyHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Add a new customer</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="customer-name" class="form-text" placeholder="Customer name *">';
				html += '<label for="customer-name">Customer name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';
				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="customer-prefix" class="form-text" placeholder="Customer prefix *">';
				html += '<label for="customer-prefix">Customer prefix <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editCompanyHTML: function(args) {

			var customer_name = ( typeof args.name !== 'undefined' ) ? '- ' + args.name + '' : '';
			var obj = {};
			var html = '';
				html += '<h2>Update customer' + customer_name + '</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="customer-name" class="form-text" placeholder="Customer name *">';
				html += '<label for="customer-name">Customer name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';
				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="customer-prefix" class="form-text" placeholder="Customer prefix *">';
				html += '<label for="customer-prefix">Customer prefix <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteCompanyHTML: function(args) {

			var customer_name = ( typeof args.name !== 'undefined' ) ? '<strong>' + args.name + '</strong>' : 'this customer';
			var obj = {};
			var html = '';
				html += '<h2>Delete customer</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete ' + customer_name + '?</p>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';
				html += '<button id="modal-btn-cancel" class="btn secondary">Cancel</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		errorHTML: function(error, level) {
            var errorElem = document.getElementById('modal-error');
                if(null == errorElem){ return; }

                errorElem.innerHTML = error;

                if( level !== '')
                	errorElem.classList.add(level);
        },

        clearError: function() {
            company.errorHTML('', '');
            $('.modal-content').find('input').each( function(i,v){
            	$(v).removeClass('error');
            });
            $('.modal-content').find('select').each( function(i,v){
            	$(v).removeClass('error');
            });
            $('#modal-error').addClass('hidden');
        },

		add: function(modal_dataset, args) {
			var btnCta 		= document.getElementById('modal-btn-cta');
			var inputData 	= getInputFieldVals('#anchorModal .input-wrapper');

			var settings = {
				apiclass	: 'company',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					//throbber(btnCta);
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						company.clearError();
						//company.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						company.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					disable_button(btnCta, false);
					if (data.error && typeof data.error !== 'function' ) {
						company.errorHTML(data.error, data.level);
						return;
					}
					company.errorHTML('There was a data error when trying to connect.', 'fatal');
				}
			});
		},

		edit: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');
			var inputData = getInputFieldVals('#anchorModal .input-wrapper');

			var settings = {
				apiclass	: 'company',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						company.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#customer-name').val(data.term.name);
							$('#customer-prefix').val(data.term.customer_prefix);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							company.edit(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						company.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					disable_button(btnCta, false);
					if (data.error && typeof data.error !== 'function' ) {
						company.errorHTML(data.error, data.level);
						return;
					}
					company.errorHTML('There was a data error when trying to connect.', 'fatal');
				}
			});
		},

		delete: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('#anchorModal .input-wrapper');

			var settings = {
				apiclass	: 'company',
				method		: 'delete',
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						company.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					disable_button(btnCta, false);
					if (data.error && typeof data.error !== 'function' ) {
						company.errorHTML(data.error, data.level);
						return;
					}
					company.errorHTML('There was a data error when trying to connect.', 'fatal');
				}
			});
		},
	}

	var contact = {
		addContactHTML: function(args) {
			var name = (typeof args.name !== 'undefined' && args.name !== '' ) ? ' for ' + args.name : '';

			var obj = {};
			var html = '';
				html += '<h2>Add contact' + name + '</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="contact-fullname" class="form-text" placeholder="Contact full name *">';
				html += '<label for="contact-fullname">Contact full name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="contact-phone" class="form-text" placeholder="Phone number">';
				html += '<label for="contact-phone">Phone number</label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="email" id="contact-email" class="form-text" placeholder="Email *">';
				html += '<label for="contact-email">Email <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item radio-item">';
				html += '<input id="documentation-perm" name="access-type" class="form-text" type="radio">';
				html += '<label for="documentation-perm">Manager access</label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item radio-item">';
				html += '<input id="contact-invoices" name="access-type" class="form-text" type="radio">';
				html += '<label for="contact-invoices">Invoice access</label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item radio-item">';
				html += '<input id="contact-limited" name="access-type" class="form-text" type="radio">';
				html += '<label for="contact-limited">Limited access</label>';
				html += '</div>';

				html += '<div class="input-wrapper text-item">';
				html += '<a href="#" class="clear-access">Clear access type</a>';
				html += '</div>';

				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editContactHTML: function(args) {
			var contact_fullname = ( typeof args.fullname !== 'undefined' ) ? '- ' + args.fullname + '' : '';
			var contact_limited = ( typeof args.limited !== 'undefined' && args.limited == true ) ? 'checked' : '';
			var documentation_perm = ( typeof args.docs !== 'undefined' && args.docs == true ) ? 'checked' : '';
			var contact_invoices = ( typeof args.invoices !== 'undefined' && args.invoices == true ) ? 'checked' : '';
			console.log(args)
			var obj = {};
			var html = '';
				html += '<h2>Update contact ' + contact_fullname + '</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="contact-fullname" class="form-text" placeholder="Contact full name *">';
				html += '<label for="contact-fullname">Contact full name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="contact-phone" class="form-text" placeholder="Phone number">';
				html += '<label for="contact-phone">Phone number</label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="email" id="contact-email" class="form-text" placeholder=Email *"">';
				html += '<label for="contact-email">Email <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item radio-item">';
				html += '<input id="documentation-perm" name="access-type" class="form-text" type="radio" ' + documentation_perm + '>';
				html += '<label for="documentation-perm">Manager access</label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item radio-item">';
				html += '<input id="contact-invoices" name="access-type" class="form-text" type="radio" ' + contact_invoices + '>';
				html += '<label for="contact-invoices">Invoice access</label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item radio-item">';
				html += '<input id="contact-limited" name="access-type" class="form-text" type="radio" ' + contact_limited + '>';
				html += '<label for="contact-limited">Limited access</label>';
				html += '</div>';

				html += '<div class="input-wrapper text-item">';
				html += '<a href="#" class="clear-access">Clear access type</a>';
				html += '</div>';

				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback

			return obj;
		},

		deleteContactHTML: function(args) {

			var contact_fullname = ( typeof args.fullname !== 'undefined' ) ? '<strong>' + args.fullname + '</strong>' : 'this contact';
			var obj = {};
			var html = '';
				html += '<h2>Delete contact</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete ' + contact_fullname + '?</p>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';
				html += '<button id="modal-btn-cancel" class="btn secondary">Cancel</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		errorHTML: function(error, level) {
            var errorElem = document.getElementById('modal-error');
                if(null == errorElem){ return; }

                errorElem.innerHTML = error;

                if( level !== '')
                	errorElem.classList.add(level);
        },

        clearError: function() {
            company.errorHTML('', '');
            $('.modal-content').find('input').each( function(i,v){
            	$(v).removeClass('error');
            });
            $('.modal-content').find('select').each( function(i,v){
            	$(v).removeClass('error');
            });
            $('#modal-error').addClass('hidden');
        },

		addContact: function(modal_dataset, args) {
			var btnCta 		= document.getElementById('modal-btn-cta');
			var inputData 	= getInputFieldVals('#anchorModal .input-wrapper');
			
			company_tid = args.tid;

			var settings = {
				apiclass	: 'contact',
				method		: 'add',
				tid 			: company_tid
			}
			$.extend(settings, inputData);

			$().customAjax({

				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					//throbber(btnCta);
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						company.clearError();
						//company.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						company.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					disable_button(btnCta, false);
					if (data.error && typeof data.error !== 'function' ) {
						company.errorHTML(data.error, data.level);
						return;
					}
					company.errorHTML('There was a data error when trying to connect.', 'fatal');
				}
			});
		},

		edit: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');
			var inputData = getInputFieldVals('#anchorModal .input-wrapper');

			var settings = {
				apiclass	: 'contact',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid,
				uid 		: args.uid
			}
			$.extend(settings, inputData);


			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						company.clearError();

						// REGENERATE THE FIELD VALUES
						if( data.account ) {
							$('#contact-fullname').val(data.account.fullname);
							$('#contact-phone').val(data.account.phone);
							$('#contact-email').val(data.account.email);
						}

						if( args.reload ) {
							location.reload();
						}
						
						$('a.clear-access').click(function(e) {
							e.preventDefault();
							$('#anchorModal .input-wrapper input[type="radio"]').attr('checked', false);
						});
					
						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							contact.edit(
								modal_dataset,
								{
									tid 	: args.tid,
									uid 	: args.uid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						company.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					disable_button(btnCta, false);
					if (data.error && typeof data.error !== 'function' ) {
						company.errorHTML(data.error, data.level);
						return;
					}
					company.errorHTML('There was a data error when trying to connect.', 'fatal');
				}
			});
		},

		delete: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('#anchorModal .input-wrapper');

			var settings = {
				apiclass	: 'contact',
				method		: 'delete',
				tid 		: args.tid,
				uid 		: args.uid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						company.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					disable_button(btnCta, false);
					if (data.error && typeof data.error !== 'function' ) {
						company.errorHTML(data.error, data.level);
						return;
					}
					company.errorHTML('There was a data error when trying to connect.', 'fatal');
				}
			});
		},
	}

	var getInputFieldVals = function(elem) {
		var inputs = {};

		$(elem).find('input').each(function(i, v) {
			if( v.type == 'text' ) {
				inputs[$(v).attr('id')] = $(v).val();
			}

			if( v.type == 'email' ) {
				inputs[$(v).attr('id')] = $(v).val();
			}

			if( v.type == 'checkbox' ) {
				inputs[$(v).attr('id')] = $(v).is( ":checked" );
			}

			if( v.type == 'radio' ) {
				inputs[$(v).attr('id')] = $(v).is( ":checked" );
			}
		});

		$(elem).find('select').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		$(elem).find('textarea').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		return inputs;
	}

	var invalidFields = function(fields) {
        for (var i in fields) {
            if (!fields[i].valid) {
                $('#' + i).addClass('error');
            } else {
                $('#' + i).removeClass('error');
            }
        }
    }

  var disable_button = function(el, disable) {
		if( disable ) {
			el.setAttribute('disabled', true);
			el.classList.add('disabled');
		}
		else{
			el.removeAttribute('disabled', false);
			el.classList.remove('disabled');
		}
	}

	Drupal.behaviors.archiveUploads = {
		// Display the older files as archived
	  attach: function (context, settings) {
			var $fileTable = $('.field-name-field-rate table[id^="edit-field-rate"]');
			if ($fileTable.length) {

				if ( $('tbody tr.archived-label', $fileTable).length === 0 ) {
					$('tbody tr:last-child', $fileTable).after('<tr class="archived-label"><td colspan="10"><strong>Rates Archive</strong></td></tr>');
				}

				$('tbody tr', $fileTable).each(function () {
					$('input[name="field_rate_archive_button"]', this).remove();
					var fileState = $('[class$="description"] input', this).val();
					if ( fileState != 'archived' && fileState != undefined) {
						$(this).append('<td><input name="field_rate_archive_button" value="Archive" class="form-submit ajax-processed" type="submit"></td>');
					} else {
						$(this).insertAfter('tr.archived-label');
					}
				});

				$('tbody tr input[name="field_rate_archive_button"] ', $fileTable).click( function (e) {
					e.preventDefault();
					var $tr = $(this).closest('tr');
					$('input[id$="description"]', $tr).val("archived");
					$('select[id$="weight"] option:last', $tr).attr("selected", "selected");
					$(this).closest('form').submit();
				});

			}
	  }
	};

	function customerSaveAndSend() {
		if ( $('body').hasClass('page-taxonomy-term-edit') ) {

			// Save and Send behaviour..
			var $saveAndSend = $('#taxonomy-form-term .form-submit-send');
			$saveAndSend.click( function(e) {
				var $sendInput = $('#taxonomy-form-term .field-name-field-send-mail input[type="checkbox"]');
				var $save = $('#taxonomy-form-term input#edit-submit');
				$sendInput.prop( 'checked', true );

				var emailNames = $('#notification-email').val().trim();

				// Binding Behaviour for modal send
				// Close Modal
				$('#anchorModal .modal-content').on('click', '#modal-send-cancel', function() {
					$('.modal-close').click();
				});

				// Attach log and Send
				$('#anchorModal .modal-content').on('click', '#modal-send', function() {

					// Reset errors
					$('#notification-email').removeClass('error');
					$('#notification-message').removeClass('error');

					// Get values
					var subject = $('#notification-subject').val().trim();
					var message = $('#notification-message').val().trim();

					// Verify and send
					if ( emailNames && message && subject) {
						$('.field-name-field-mail-subject input').val(subject);
						$('.field-name-field-mail-message input').val(message);
						// Save and close modal
						$save.click();
						$('.modal-close').click();
					} else {
						// Verification failed
						if (!emailNames) $('#notification-email').addClass('error').attr('placeholder', 'There are no managers for this company');
						if (!subject) $('#notification-subject').addClass('error').attr('placeholder', 'Please type in a subject');
						if (!message) $('#notification-message').addClass('error').attr('placeholder', 'Please type in a message');
					}
				});

				// Attach the form and open Modal
				$("#anchorModal .modal-content").addClass('modal--save-and-send');
				$("body").addClass("modal-open");
			});
		}
	}

	function orderArchivedRates() {
		if ( $(".taxonomy-term.vocabulary-customer-company-.view-mode-full").length ) {
			// if there are archived files
			if ( $('.file.rate-archived').length ) {
				// Create a wrapper...
				$('.field-name-field-rate').after('<div class="field field-name-field-rate-archived"><div class="field-label">Archived rates</div><div class="field-items"></div></div>');
				// ..and move them inside
				$('.file.rate-archived').each( function () {
					$(this).appendTo('.field-name-field-rate-archived .field-items');
				});
			}
		}
	}

	Drupal.behaviors.certsBehavoiur = {
		attach: function (context, settings) {
			// N/A default state
			$('.certs-wrapper input.form-checkbox').each( function( index, element ) {
				checkCertNA(this);
			});
			// N/A behaviour
			$('.certs-wrapper input.form-checkbox').change(function() {
				checkCertNA(this);
				Drupal.behaviors.calculateDocs.attach(document, Drupal.settings);
			})
			function checkCertNA(checkbox) {
				var $input = $(checkbox).closest('.certs-wrapper').find('input[type=file]');
				if ($(checkbox).prop('checked')) {
					$input.prop('disabled', true);
					$input.parent().parent().addClass('disabled');
				} else {
					$input.prop('disabled', false);
					$input.parent().parent().removeClass('disabled');
				}
			}

			// Check cert radio default
			!$('#edit-field-step-1-certs-required-und-1').is(':checked') && hideCerts();
			// Check Cert form change
			$('input[type=radio][name="field_step_1_certs_required[und]"]').change(function() {
				this.value == 0 ? hideCerts() : showCerts();
				Drupal.behaviors.calculateDocs.attach(document, Drupal.settings);
			});
			function hideCerts() {
				$('.certs-wrapper .form-item').addClass('disabled');
				$('.certs-wrapper').hide();
			}
			function showCerts() {
				$('.certs-wrapper').show().find('.form-item').removeClass('disabled');
			}

			// Sent trigger
			$('.field-name-field-step-2-sent input[type=checkbox]').change(function() {
				Drupal.behaviors.calculateDocs.attach(document, Drupal.settings);
			});
			$('.field-name-field-step-3-sent input[type=checkbox]').change(function() {
				Drupal.behaviors.calculateDocs.attach(document, Drupal.settings);
			});
			$('.field-name-field-step-4-sent input[type=checkbox]').change(function() {
				Drupal.behaviors.calculateDocs.attach(document, Drupal.settings);
			});
			$('div[class$="field-checked-by-anchor-und"] input[type=checkbox]').change(function() {
				Drupal.behaviors.calculateDocs.attach(document, Drupal.settings);
			});
		}
	};

	function editDocs() {
		// Logs
		if ( $("#edit-field-documentation-notes").length ) {
			$('#edit-submit').click( function(e) {
				e.preventDefault();
				// Compile a log message of all the step notes fields joined together.
				var logMessage = "";
				$('textarea[id$="-notes-und-0-value"]').each( function(i) {
					var idParts = $(this).attr('id').split('-');
					var noteNumber = '';
					if (idParts.length > 3) {
						noteNumber = idParts[3];
					}
					var note = $(this).val().trim();
					if (note != "") {
						if (logMessage != "") logMessage += "<br>"
						logMessage += noteNumber + '. ' + note + '\n';
					}
				});
				var notesHaveChanged = false;
				var hasExistingNotes = false;
				// Check whether or not that message matches the last non-email-notification
				// notes entry. If it doesn't it means the notes have been edited and we
				// should save a new entry.
				var $existingNotesFields = $('#field-documentation-notes-values tbody .field-name-field-doc-notes-message .form-item textarea');
				// Iterate over them in reverse order as we want the most recent first.
				// get() will return an array of elements, which is then reversed and
				// then passed into the outer jQuery function, which is then iterated on
				// with each().
				$($existingNotesFields.get().reverse()).each(function(i) {
					// The first entry in the reversed list will always be the new notes
					// field and will be empty, so skip it.
					if (i == 0) {
						return true;
					}
					var $existingNotesField = $(this);
					var notesText = $existingNotesField.val();
					// Exclude email notifications.
					if (!notesText.startsWith('Email notification')) {
						hasExistingNotes = true;
						// If our new log message differs from the last note text, flag that
						// we should save.
						if (notesText != logMessage) {
							notesHaveChanged = true;
						}
						// Since we are only interested in the first non-email-notification,
						// break out of the each() loop.
						return false;
					}
				});
				// If there's a new message, save it.
				if (!hasExistingNotes || notesHaveChanged) {
					var $newLog = $('#field-documentation-notes-values > tbody > tr:last-child');
					if (logMessage != '') {
						$('textarea', $newLog).prop('disabled', false).val(logMessage);
					}
				}
				$('#edit-submit').closest('form').submit();
			});
		}
	}

	Drupal.behaviors.calculateDocs = {
		// Display the older files as archived
	  attach: function (context, settings) {

			if ( $('body.page-field-collection-field-documentation').length) {

				// Prepping the selectors conditionally...
				if ( $('body.page-field-collection-field-documentation-edit').length) {
					// ...in documentation edit form
					var certRequired = $('input#edit-field-step-1-certs-required-und-1').is(':checked'); // Bool
					var rowSelector = '.field-type-field-collection .field-multiple-table > tbody > tr';
					var certsWrapper = '.certs-wrapper';
					var naBool = function (that) {return $('input[type="checkbox"]', that).prop('checked') };
				} else {
					// ...in documentation display only
					var certRequired = ($('.field-name-field-step-1-certs-required .field-item').text().trim() == "Yes"); // Bool
					var rowSelector = '.field-type-field-collection > .field-items > .field-item .entity-field-collection-item > .content';
					var certsWrapper = '.group-certs-wrapper';
					var naBool = function (that) {return $('.checkbox-display-container--na.checked', that).length > 0 };
					if (!certRequired) $(certsWrapper).hide();
				}

				// If we're in the documentation section
				var $accordionWrapper = $('.group-steps.field-group-accordion-wrapper');

				var counter = '<div class="group-status">';

				counter +=			'<div class="group-status-docs">';
				counter += 				'<span class="group-status-count"><span class="group-status-count-1">0</span>/<span class="group-status-count-2">0</span></span>';
				counter += 				'<span class="group-status-desc"> Documents <i>Received</i></span>';
				counter += 			'</div>';
				if (certRequired) {
					counter +=		'<div class="group-status-certs">';
					counter += 			'<span class="group-status-count"><span class="group-status-count-1">0</span>/<span class="group-status-count-2">0</span></span>';
					counter += 			'<span class="group-status-desc"> Certs <i>Received</i></span>';
					counter += 		'</div>';
				}
				counter += 		'</div>';

				var counterSend = '<div class="group-status">';
				counterSend +=			'<div class="group-status-docs">';
				counterSend += 				'<span class="group-status-count"><span class="group-status-count-1">0</span>/<span class="group-status-count-2">0</span></span>';
				counterSend += 				'<span class="group-status-desc"> Documents <i>Sent</i></span>';
				counterSend += 			'</div>';
				counterSend += 		'</div>';

				var counterApproved = '<div class="group-status">';
				counterApproved +=			'<div class="group-status-docs">';
				counterApproved += 				'<span class="group-status-count"><span class="group-status-count-1">0</span>/<span class="group-status-count-2">0</span></span>';
				counterApproved += 				'<span class="group-status-desc"> Documents <i>Approved</i></span>';
				counterApproved += 			'</div>';
				counterApproved += 		'</div>';

				$('> h3', $accordionWrapper).each( function (i) {
					// For each group, append the empty counter (if not done yet).
					var counterHtml;
					if ($(this).next().hasClass('group-step-2')) {
						counterHtml = counterSend;
					} else if ($(this).next().hasClass('group-step-4')) {
						counterHtml = counterApproved;
					// } else if ($(this).next().hasClass('group-step-5')) {
					} else if ($(this).next().hasClass('group-step-6')) {
						counterHtml = null;
					} else {
						counterHtml = counter;
					}

					if (counterHtml) {
						if ( !$('.group-status', this).length ) {
							$(this).append(counterHtml);
						} else {
							$('.group-status', this).replaceWith(counterHtml);
						}
					}

					// Add save button to each accordion
					// $(this).once('addSaveButton', function() {
					// 	$(this).next()
					// 	.append('<button class="btn group-save" type="button">Save</button>')
					// 	.on("click", "button.group-save", function() {
					// 		$('#edit-submit').click();
					// 	});
					// });

					// Individual row selector
					var $fileRow = $(this).next().find(rowSelector);
					// Set the toal for each group
					var totalRow = $fileRow.length;
					var uploadedRow = 0;
					$('.group-status-docs .group-status-count-2', this).text(totalRow);
					uploadedRow = $('.group-upload-fields > .fieldset-wrapper > .field-type-file span.file', $fileRow).length;
					// Manage the exception of sent item - Step 2
					if ($(this).next().hasClass('group-step-2')) uploadedRow = $('.field-name-field-step-2-sent input[type="checkbox"]:checked', $fileRow).length;
					// Manage the exception of Approved item - Step 4
					if ($(this).next().hasClass('group-step-4')) uploadedRow = $('.field-name-field-step-4-file-status input[type="radio"][value=1]:checked', $fileRow).length;

					// Write the count result
					$('.group-status-docs .group-status-count-1', this).text(uploadedRow);

					// This is for the row header
					var rowDocStatus = 0;
					var rowCertStatus = -1;
					// Row notification
					if (uploadedRow >= totalRow) {
						$('.group-status-docs', this).removeClass('attention').addClass('complete');
						// .find('.group-status-desc').text('Completed'); // Example for dynamic label
						rowDocStatus = 2;
					} else if (uploadedRow != 0) {
						$('.group-status-docs', this).removeClass('complete').addClass('attention');
						rowDocStatus = 1;
					} else {
						$('.group-status-docs', this).removeClass('complete attention');
					}

					if (certRequired) {
						var totalRowCert = 0;
						var uploadedRowCert = 0;
						rowCertStatus = 0;

						// Check is cert is N/A.
						// console.log($fileRow)


						if ($(certsWrapper, $fileRow).length > 0) {
							$(certsWrapper,$fileRow).each( function (r) {
								if (naBool(this)) return true; //skip the count
								totalRowCert++;
								if ($('.field-type-file span.file', this).length > 0 ) uploadedRowCert++;
							});
						} else {
							// cert wrapper missing, delete it.
							$('.group-status-certs', this).remove();
						}
						// Write the count result
						$('.group-status-certs .group-status-count-1', this).text(uploadedRowCert);
						$('.group-status-certs .group-status-count-2', this).text(totalRowCert);
						// Row notification
						if (uploadedRowCert >= totalRowCert) {
							$('.group-status-certs', this).removeClass('attention').addClass('complete');
							rowCertStatus = 2;
						} else if (uploadedRowCert != 0) {
							$('.group-status-certs', this).removeClass('complete').addClass('attention');
							rowCertStatus = 1;
						} else {
							$('.group-status-certs', this).removeClass('complete attention');
						}
					}

					// Add class on header H3
					// This works on the status calculated Above
					// 0 => empty, 1 => partially complete, 2 => complete
					$(this).removeClass('status-complete status-attention');

					if ( !$(this).next().hasClass('group-step-5') ) {

						if (rowCertStatus >= 0) {
							if (rowDocStatus > 0 || rowCertStatus > 0) {
								if (rowDocStatus === 2 && rowCertStatus === 2) {
									$(this).addClass('status-complete');
								} //else if ((rowDocStatus + rowCertStatus) > 0) {
								 	//$(this).addClass('status-attention');
								//\\}
							}
						} else {
							if ( rowDocStatus > 0) {
								rowDocStatus === 1 && $(this).addClass('status-attention');
								rowDocStatus === 2 && $(this).addClass('status-complete');
							}
						}
					}

					if ($(this).next().hasClass('group-step-2')) {
						// console.log(uploadedRow + ' / ' + totalRow);
						if ( uploadedRow === totalRow ) {
							$(this).addClass('status-complete');
						}
					}

					if ($(this).next().hasClass('group-step-4')) {
						if ( $(this).prev('.group-step-3').prev('h3').hasClass('status-complete') ) {
						// if ( $('body').hasClass('role-client')  ) {
							if ( uploadedRow === totalRow ) {
								$(this).addClass('status-complete').removeClass('status-attention');
							} else {
								$(this).addClass('status-attention').removeClass('status-complete');

							}
						// }
						} else {
							$(this).removeClass('status-complete');
							$(this).removeClass('status-attention');
						}
					}

					if ($(this).next().hasClass('group-step-5')) {
						var selects = [];
						$(this).next().find('select.form-select[id^="edit-field-step-5-"]').each(function() {
							if( !$(this).attr('name').endsWith('[_weight]') ) {
								selects.push($(this).val());
							}
						});

						// console.log(selects);

						if ($.inArray("_none", selects) === -1)  {
							$(this).addClass('status-complete');
						}
					}

					if (totalRow === 0) {
						$(this).removeClass('status-complete status-attention');
					}
				});
				forwardInstruction();
				draftAmendments();
				disableCheckedByAnchor();
			}

	  } // end attach() behaviour
	};

	function forwardInstruction() {
			if ( $('body.page-field-collection-field-documentation').length) {
				if (Drupal.settings.isAnchor) {
					// Prepping the selectors conditionally...
					var $t1 = $('#field-step-1-values');
					var $t2 = $('#field-step-2-values');
					// Reset previous values
					$('.group-upload-fields', $t2).remove();
					// Populate the set
					$('.group-upload-fields', $t1).each( function (i) {
						// Generates row from previous fieldset
						var $row = $('.group-reference:eq('+i+')', $t2);
						var $filledRow = $(this).clone().insertAfter($row);
						$filledRow.find('input, .field-name-field-step-1-na').remove();
						$('.form-type-managed-file', $filledRow).each( function () {
							if ( $(this).find('.file-widget > span.file').length === 0 ) {
								// Empty: not uploaded yet
								$filledRow.find('.description').addClass('not-uploaded'); // .text('Not uploaded')
								$filledRow.find('.description').parent().addClass('not-uploaded-container');
							}
						});
						// Add class on notification
						if($row.parent().find('.field-name-field-step-2-sent input[type="checkbox"]:checked').length) {
							$row.closest('tr').addClass('notification-sent');
						}

						if ( $('body.page-field-collection-field-documentation-edit').length) {
							if (Drupal.settings.isAnchor) {
								var sendButton = '<button type="button" class="send-button" data-row="'+i+'" disabled>Send to Shipping Line & Save</button>';
								// Adding send button for each row, if in edit mode
								var $sendingRow = $filledRow.parent().parent().find('.group-actions > .fieldset-wrapper .field-name-field-step-2-sent');
								$sendingRow.once('addStep2Button', function() {
									$(this).append(sendButton).on('click', 'button', function(e) {
										sendDocumentation($row.parent(), e);
									});
								});
								if ($('.form-item:not(.disabled) .not-uploaded', $filledRow).length === 0) {
									// enable the button added above, if is ready to be sent
									$('.send-button', $sendingRow).prop('disabled', false);
								}
							}
						}
					});

				} else {
					// If it's not anchor user, remove the remaing bit and the open behaviour
					 $('.group-step-2.field-group-accordion-item').prev().off().find('span.ui-accordion-header-icon').remove();
					 // $('.group-step-2.field-group-accordion-item').remove();
				}
			}
	};

	function draftAmendments() {
			if ( $('body.page-field-collection-field-documentation').length) {

				var $drafts = $('#field-step-3-values');
				var $amendments = $('#field-step-4-values');
				var noFile = '<div class="form-item form-type-managed-file not-uploaded-container draft-cloned"><label>Label </label><div class="description not-uploaded"><br><strong>File not uploaded.</strong></div></div>';
				var clonedContainerHtml = '<div class="fieldset-wrapper-cloned clearfix">';
						clonedContainerHtml += 		'<div class="field-type-file field-name-field-step-4-draft-bill-cloned form-wrapper"></div>';
						clonedContainerHtml += 		'<div class="certs-wrapper">';
						clonedContainerHtml += 			'<div class="field-type-file field-name-field-step-4-certs-cloned form-wrapper"></div>';
						clonedContainerHtml += 		'</div>';
						clonedContainerHtml += '</div>';

				var clonedActionsContainerHtml = '<div class="fieldset-wrapper-cloned clearfix">';
						clonedActionsContainerHtml +=		'<div class="field-type-list-boolean field-name-field-checked-by-anchor-cloned field-widget-options-onoff form-wrapper"></div>';
						clonedActionsContainerHtml += '</div>';

				var allDraftBillsSent = 0;
				// Reset prev values
				$('.fieldset-wrapper-cloned', $amendments).remove();

				$('.group-actions', $drafts).each(function(i) {
					var $checked_by_anchor = $('.group-actions:eq(' + i + ') .field-name-field-checked-by-anchor input', $drafts);
					if ($checked_by_anchor.length) {
						var $clonedContainer = $('.group-actions:eq(' + i + ') .field-name-field-step-4-file-status', $amendments).prepend(clonedActionsContainerHtml).find('.fieldset-wrapper-cloned');
						var $amendContainer = $clonedContainer.find('.field-name-field-checked-by-anchor-cloned');
						var $cloned_checkbox_label = $checked_by_anchor.next('label').clone();
						if ($checked_by_anchor.is(':checked')) {
							$cloned_checkbox_label.addClass('checked');
						}
						$cloned_checkbox_label.appendTo($amendContainer);
						$checked_by_anchor.change(function() {
							if (this.checked) {
								$cloned_checkbox_label.addClass('checked');
							} else {
								$cloned_checkbox_label.removeClass('checked');
							}
						});
					}
				});

				$('.group-upload-fields', $drafts).each(function(i) {
					var $this = $(this);

					var $clonedContainer = $('.group-upload-fields:eq('+i+')', $amendments).prepend(clonedContainerHtml).find('.fieldset-wrapper-cloned');
					var $originalFormWrapper = $('.group-upload-fields:eq('+i+') .fieldset-wrapper', $amendments);

					// get the draft and the amendment for this row
					var $draft = $('.field-name-field-step-3-draft-bill .form-type-managed-file', $this);
					var $amendment = $('.field-name-field-step-4-draft-bill:eq('+i+') .form-type-managed-file', $amendments);

					var $draftCert = $('.field-name-field-step-3-certs .form-type-managed-file', $this);
					var $amendmentCert = $('.field-name-field-step-4-certs:eq('+i+') .form-type-managed-file', $amendments);

					var $amendContainer = $clonedContainer.find('.field-name-field-step-4-draft-bill-cloned');
					var $amendCertContainer = $clonedContainer.find('.field-name-field-step-4-certs-cloned');

					var step3ApprovedSent = '';
					var step4AmendSent = '';

					// Copy Draft to amedments, (if not empty)
					if ($('span.file', $draft).length) {
						$draft.clone().appendTo($amendContainer).find('input').remove();
						// $('.field-name-field-step-4-file-status:eq('+i+')').removeClass('tempDisabled');
						$('#field-step-4-values tbody tr:nth-of-type(' + (i+1) + ')').removeClass('disableSend');
					} else {
						$this.parent().find('input[id$="sent-und"]').prop("checked", false);
						// $clonedContainer.parent().parent().find('input.form-radio[value="_none"]').click();
						// $('.field-name-field-step-4-file-status:eq('+i+')').addClass('tempDisabled');
						$('#field-step-4-values tbody tr:nth-of-type(' + (i+1) + ')').addClass('disableSend');
						$(noFile).appendTo($amendContainer).find('label').text('Draft bill');
						$clonedContainer.parent().parent().find('.isSent').removeClass('isSent');
						$('#edit-field-step-3-und-' + i + '-field-step-3-sent-und').prop("checked", false);
						$('#edit-field-step-4-und-' + i + '-field-step-4-sent-und').prop("checked", false);
					}

					// Copy Cert to amedments, (if not empty or needed)
					if ($('span.file', $draftCert).length) {
						$draftCert.clone().appendTo($amendCertContainer).find('input').remove();
						// $('.field-name-field-step-4-file-status:eq(' + (i+1) + ')').removeClass('tempDisabled');
					} else {
						var $clonedCert = $(noFile).appendTo($amendCertContainer);
						$clonedCert.find('label').text('Draft cert');
						if ($draftCert.hasClass('disabled')) {
							$clonedCert.addClass('disabled');
							$amendmentCert.addClass('disabled').find('input').attr('disabled','disabled');
							// $('.field-name-field-step-4-file-status:eq('+i+')').removeClass('tempDisabled');
							$('#field-step-4-values tbody tr:nth-of-type(' + (i+1) + ')').removeClass('disableSend');

						} else {
							$this.parent().find('input[id$="sent-und"]').prop("checked", false);
							// $clonedContainer.parent().parent().find('input.form-radio[value="_none"]').click();
							// $('.field-name-field-step-4-file-status:eq('+i+')').addClass('tempDisabled');
							$('#field-step-4-values tbody tr:nth-of-type(' + (i+1) + ')').addClass('disableSend');
							$clonedContainer.parent().parent().find('.isSent').removeClass('isSent');
							$('#edit-field-step-3-und-' + i + '-field-step-3-sent-und').prop("checked", false);
							$('#edit-field-step-4-und-' + i + '-field-step-4-sent-und').prop("checked", false);
						}
					}
					if ($('#edit-field-step-3-und-' + i + '-field-step-3-sent-und:checked').length) {
						step3ApprovedSent = 'isSent';
						allDraftBillsSent++;
					} else {
						step3ApprovedSent = '';
					}
					
					if ($('#edit-field-step-4-und-' + i + '-field-step-4-sent-und:checked').length) {
						step4AmendSent = 'isSent';
					} else {}
					step4AmendSent = '';

					if (allDraftBillsSent < $('.group-upload-fields', $drafts).length ) {
						$('#ui-id-7').removeClass('status-complete');
					} else {
						$('#ui-id-7').addClass('status-complete');
					}

					// Hide show amendments, if amendments are required
					if (Drupal.settings.isAnchor) {
						// Add send buttons
						var sendApprovedButton = $('<button type="button" class="send-button send-approve-button ' + step3ApprovedSent + '" data-row="' + i + '" disabled>Send approval to Shipping Line & Save</button>');
						var sendAmendButton = $('<button type="button" class="send-button send-amend-button ' + step4AmendSent + '" data-row="' + i + '" disabled>Send amendment to Shipping Line & Save</button>');
						$('.group-actions:eq(' + i + ')', $amendments).once('addStep4Button', function() {
							sendApprovedButton.on('click', function(e) {
								// This parent will correspond with step 3.
								sendDocumentation($this.parent(), e);
							}).appendTo($(this));
							sendAmendButton.on('click', function(e) {
								// This parent will correspond with step 4.
								sendDocumentation($(this).parent().parent(), e);
							}).appendTo($(this));
						});
					}
					// Setting defaults
					var $status = $('.field-name-field-step-4-file-status:eq('+i+') input:checked').val();
					if ($status === '1') {
						// OPTIONALLY, check if the files are filled in
						$('.group-actions:eq(' + i + ') .send-amend-button', $amendments).prop('disabled', true);
						$('.group-actions:eq(' + i + ') .send-approve-button', $amendments).prop('disabled', false);
					} else if ($status === '0') {
						$('.group-actions:eq(' + i + ') .send-amend-button', $amendments).prop('disabled', false);
						$('.group-actions:eq(' + i + ') .send-approve-button', $amendments).prop('disabled', true);
					} else {
						$('.group-actions:eq(' + i + ') .send-amend-button', $amendments).prop('disabled', true);
						$('.group-actions:eq(' + i + ') .send-approve-button', $amendments).prop('disabled', true);
					}
					$('.field-name-field-step-4-file-status:eq('+i+') input[type="radio"]').once('step4AttachCalc', function() {
						$status !== '0' && $originalFormWrapper.hide();
						$(this).change( function() {
							$(this).each( function(a) {
								var $originalFormWrapper = $(this).closest('td').find('.group-upload-fields .fieldset-wrapper');
								if ($(this).val() === '0') {
									$originalFormWrapper.slideDown();
								} else {
									$originalFormWrapper.slideUp();
								}
							});
							Drupal.behaviors.calculateDocs.attach();
						});
					});
				});

				if (allDraftBillsSent === 4) {
					$('#ui-id-7').removeClass('status-attention');
					$('#ui-id-7').addClass('status-complete');
				}

				// If draft documents are uploaded, but anchor has not checked, remove completed and add attention.
				
				// var totalFiles = $('.group-upload-fields', $drafts).length;
				$('.group-upload-fields', $drafts).each(function(i) {
					var hasUploadedFile = 0;
					var hasCheckedByAnchor = 0;
					
					var $this	= $(this);
					var $draft	= $('.field-name-field-step-3-draft-bill .form-type-managed-file', $this);
					var chk 	= $('.group-actions:eq(' + i + ') .field-name-field-checked-by-anchor input', $drafts);

					if ($('span.file', $draft).length) {
						hasUploadedFile++;
					}

					if (chk.prop('checked') == true) {
						hasCheckedByAnchor++;
					}

					if ( hasUploadedFile == 1 ) {
						if ( hasCheckedByAnchor == 0 ) {
							$('#ui-id-5').removeClass('status-complete');
							$('#ui-id-5').addClass('status-attention');
						}
					}
				});
			}
	};

	// function checkedWarning() {
	// 	if ( $('body.page-field-collection-field-documentation').length) {
	// 		var $drafts = $('#field-step-3-values');

	// 	}
	// }

	function sendDocumentation($row, e) {
		var title = '';
		var subject = '';
		var confirmationSubject = '';
		var case_id = '';
		var documentFid = '';
		var certificateFid = '';
		var shippingLineRef = '';
		var shipperRef = '';
		var sendToClient = 0;

		if ( $('#slf').length ) {
			var shippingLineRef = $('#slf').html();
		}
		$('.shipper-ref').each(function() {
			if (shipperRef) {
				shipperRef += ', ';
			}
			shipperRef += $(this).html();
		})
		var ref = $('input.text-full.form-text' , $row).val();
		// TODO verify if cert is true
		var certRequired = !!$('#edit-field-step-1-certs-required-und input:checked').val();
		var cert = '';
		if (certRequired) {
			if ( $('.certs-wrapper .form-type-managed-file span.file', $row).length ) {
				cert = ' and cert';
			}
		}

		var currentUserId = Drupal.settings.currentUserId;
		// var notifyUsersId = [];
		// $('.field-name-field-notify-user input[type=checkbox]:checked').each(function() {
		// 	notifyUsersId.push($(this).val());
		// });
		var currentUrl = window.location.pathname;
		var currentUrlArray = window.location.pathname.split('/');
		var fieldCollectionId = currentUrlArray[3];
		var fieldCollectionType = currentUrlArray[2];
		var documentURL = $('.group-upload-fields > .fieldset-wrapper > .field-type-file span.file a', $row).attr('href');
		
		var certURL = '';
		if (certRequired) certURL = $('.group-upload-fields .certs-wrapper .field-type-file span.file a', $row).attr('href');

		// Verify where we are, and prep vars accordingly
		var regexp = /(?:^|\s)group-step-(.*?)(?:\s|$)/g;
		var match = regexp.exec($row.closest('.field-group-format-wrapper.field-group-accordion-item').attr('class'));
		match = $.trim(match[0]);
		switch (match) {
			case 'group-step-2':
				title = 'Send <b>FI' + cert + '</b> to <b>Shipping Line</b>';
				subject = 'Anchor FI - ' + shippingLineRef;
				case_id = 'step-2';
				break;

			case 'group-step-3':
				title = 'Approved draft bill sent to <b>Shipping line</b>';
				subject = 'Anchor draft bill approved - ' + shippingLineRef;
				confirmationSubject = 'Anchor approved draft bill sent to shipping line - ' + shippingLineRef;
				case_id = 'step-3';
				sendToClient = 1;
				break;

			case 'group-step-4':
				title = 'Amendment to draft bill sent to <b>Shipping line</b>';
				subject = 'Amendment for draft bill to Shipping line - ' + shippingLineRef;
				case_id = 'step-4';
				break;

			default:
		}
		// var subject = $('<span>'+title+'</span>').text() + " (Ref #"+ref+')';
		var rowNumber = e.currentTarget.dataset.row;

		if (case_id === 'step-2') {
			
			documentFid = $('.field-type-file input[type="hidden"][name$="field_step_1[und]['+rowNumber+'][field_step_1_fw_instructions][und][0][fid]"]').val();

			if (certRequired) {
				certificateFid = $('.field-type-file input[type="hidden"][name$="field_step_1[und]['+rowNumber+'][field_step_1_certs][und][0][fid]"]').val();
			}
		}

		if (case_id === 'step-3') {
			documentFid = $('.field-type-file input[type="hidden"][name="field_step_3[und]['+rowNumber+'][field_step_3_draft_bill][und][0][fid]"]').val();

			if (certRequired) {
				certificateFid = $('.field-type-file input[type="hidden"][name="field_step_3[und]['+rowNumber+'][field_step_3_certs][und][0][fid]"]').val();
			}
		}

		if (case_id === 'step-4') {
			documentFid = $('.field-type-file input[type="hidden"][name="field_step_4[und]['+rowNumber+'][field_step_4_draft_bill][und][0][fid]"]').val();

			if (certRequired) {
				certificateFid = $('.field-type-file input[type="hidden"][name="field_step_4[und]['+rowNumber+'][field_step_4_certs][und][0][fid]"]').val();
			}
		}

		// The email modal form itself
		var html = '';
		html += '<h2>'+title+'</h2>';
		html += '<div class="input-wrapper form-item"><input type="email" id="notification-email" class="form-text" placeholder="Shipping line\'s email address"><label for="contact-email">Shipping line\'s email address</label></div>';
		html += '<div class="input-wrapper form-item"><input type="text" id="notification-subject" class="form-text" placeholder="Subject" value="' + subject + '" readonly ><label for="notification-subject">Subject</label></div>';
		html += '<div class="input-wrapper form-item"><textarea id="notification-message" rows="5" cols="90" class="form-textarea" placeholder="Message"></textarea><label for="notification-message">Message</label></div>';
		html += '<div class="input-wrapper form-item">';
		html += '<button id="modal-send-cancel" class="btn secondary">Cancel</button> ';
		html += '<button id="modal-send" class="btn">Send</button></div>';

		// Cancel behaviuor
		$('#anchorModal .modal-content').on('click', '#modal-send-cancel', function() {
			$('.modal-close').click();
		});
		// Attach log and Send

		$('#anchorModal .modal-content').on('click', '#modal-send', function() {
			$(this).once('sending mail', function() {
				// Reset errors
				$('#notification-email').removeClass('error');
				$('#notification-message').removeClass('error');
				$(this).prop('disabled', true).addClass('sending').html('Sending...');

				// Verify and send
				var emails = $('#notification-email').val().trim();
				var message = $('#notification-message').val().trim();
				var bookingNid = parseInt($('ul#booking-links > li:first-child a').attr('href').replace('/node/',''));
				var $modal = $('.modal--send-docs');

				// Save
				var $save = $('input#edit-submit');

				if ( emails.length && message.length ) {
					var postData = {
						'subject'	: subject,
						'confirmationSubject' : confirmationSubject,
						'title'		: title,
						'emails'	: $('#notification-email').val(),
						'message'	: $('#notification-message').val(),
						'ref'		: ref,
						'caseId'	: case_id,
						'fcId'		: fieldCollectionId,
						'cuId'		: currentUserId,
						'docUrl'	: documentURL,
						'docFid'	: documentFid,
						'certUrl'	: certURL,
						'certFid'	: certificateFid,
						'parentNid'	: bookingNid,
						'sendToClient' : sendToClient
					};
					$.ajax({
						type: 'POST',
						url: '/send/mail',
						dataType: 'json',
						data: postData,
						// success: mailSenderResponse,
					}).done(function( data ) {
						$('.input-wrapper', $modal).fadeOut().remove();
						// $modal.append('<div class="input-wrapper form-item"><p>Message sent.</p><button id="modal-send-cancel" class="btn secondary">Cancel</button></div>').hide().fadeIn();
						$modal.html('<div class="messages status"><h2 class="element-invisible">Status message</h2>Message sent. Please wait while document is saved.</div>').hide().fadeIn();
						// Set sent to true.
						if ($('.field-name-field-step-2-sent', $row).length) {
							$('.field-name-field-step-2-sent input[type="checkbox"]', $row).prop( "checked", true );
							Drupal.behaviors.calculateDocs.attach();
						}

						if ($('.field-name-field-step-3-sent', $row).length) {
							$('.field-name-field-step-3-sent input[type="checkbox"]', $row).prop( "checked", true );
							Drupal.behaviors.calculateDocs.attach();
						}

						if ($('.field-name-field-step-4-sent', $row).length) {
							$('.field-name-field-step-4-sent input[type="checkbox"]', $row).prop( "checked", true );
							Drupal.behaviors.calculateDocs.attach();
						}

						// The call to send/mail will have saved a log in document notes,
						// Clicking save now will save those (also with custom code in the
						// documentation module) and also save any values we have set here.
						$save.click();

					}).fail(function() {
						$modal.append('<p class="error" style="color:#FD6275">Message not sent. Please try again later.</p>').hide().fadeIn();
						$(this).prop('disabled', false).removeClass('sending').html('Send');
					})
				} else {
					if (!emails) $('#notification-email').addClass('error').attr('placeholder', 'Please select at least one contact');
					if (!message) $('#notification-message').addClass('error').attr('placeholder', 'Please type in a message');
					$(this).prop('disabled', false).removeClass('sending').html('Send');
				}
			});
		});

		// Show modal
		$("#anchorModal .modal-content").addClass('modal--send-docs').html(html);
		$('body').addClass('modal-open');
	}

	function validateEmail(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
	}

	function viewLogs() {
		// if ( $("#block-views-documentation-log-block").length ) {
		// 	var $block = $('#block-views-documentation-log-block');
		// 	var $logs = $('.view-content', $block).hide();
		// 	// Add toggle behaviour
		// 	$('> h2', $block).click( function(e) {
		// 		$logs.slideToggle();
		// 		$(this).toggleClass('open');
		// 	});
		// }
	}

	function disableCheckedByAnchor() {
		var $row = $('#field-step-3-values tbody').find('tr');

		$row.each( function() {
			// Status
			// 0 = no files
			// 1 = has a bill
			// 2 = has a cert / cert na
			// 3 = has both a bill and a cert or cert na
			var status = 0;

			if ( $(this).find('.field-type-file[id$="-bill"] .file').length ) {
				if ( $(this).find('.field-type-file[id$="-certs"] .file').length ) {
					status = 3;
				} else {
					status = 1;

					if ( $(this).find('input[id$="-na-und"]').is(':checked') ) {
						status = 3;
					}
				}
			} else {
				if ( $(this).find('.field-type-file[id$="-certs"] .file').length ) {
					status = 2;
				} else {
					status = 0;

					if ( $(this).find('input[id$="-na-und"]').is(':checked') ) {
						status = 2;
					}
				}
			}

			// Does the field require certs?
			var reqcerts = 0;
			if ( $('#edit-field-step-1-certs-required-und-1').is(':checked') ) {
				reqcerts = 1;
			}

			var $checkedby = $(this).find('input[id$="checked-by-anchor-und"]');
			if ( reqcerts == 0 ) {
				if ( status == 0 || status == 2) {
					$checkedby.prop('disabled', true);
					$checkedby.prop('checked', false);
				}
			} else {
				if (status == 3) {
					$checkedby.prop('disabled', false);
				} else {
					$checkedby.prop('disabled', true);
					$checkedby.prop('checked', false);
				}
			}
		});
	}
	$('input[type=radio][name="field_step_1_certs_required[und]"], input[id$="-step-3-na-und"]').change(function() {
		disableCheckedByAnchor();
	});

})(jQuery, Drupal)
